import './App.css'
import { useEffect } from 'react';
import Container from './section/Container/Container'
import Footer from './section/Footer/Footer'
import Header from './section/Header/Header'
import Home from './pages/Home/Home'
import Login from './pages/Login/Login'
import Register from './pages/Register/Register'
import Account from './pages/Account/Account'
import Admin from './pages/Admin/Admin'

import AOS from 'aos';
import { ToastContainer } from 'react-toastify';

import { HashRouter as Router, Route, Routes } from 'react-router-dom'
const App = () => {
  useEffect(() => {
    AOS.init();
  }, [])
  return (
    <>
      <ToastContainer theme='colored' position='top-center'></ToastContainer>
      <Router>
        <Header />
        <Container>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/login' element={<Login />} />
            <Route path='/register' element={<Register />} />
            <Route path='/account' element={<Account />} />
            <Route path='/admin' element={<Admin />} />
          </Routes>
        </Container>
        <Footer />
      </Router>
    </>
  )
}

export default App
